
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { User, Building2, Microscope, Award, Lightbulb } from "lucide-react";

const WhoAttendsSection = () => {
  const attendeeGroups = [
    {
      id: 1,
      title: "Tech Executives & Decision Makers",
      description: "CTOs, CIOs, and technology leaders seeking to implement AI strategies in their organizations",
      icon: <Building2 className="h-10 w-10 text-purple-500" />,
      image: "/lovable-uploads/7aa95104-2d1a-4648-883d-9bf30cf35964.png"
    },
    {
      id: 2,
      title: "AI Researchers & Scientists",
      description: "Leading minds advancing the frontiers of artificial intelligence and machine learning",
      icon: <Microscope className="h-10 w-10 text-purple-500" />,
      image: "/lovable-uploads/59a2269a-fbd4-4041-b705-4c6c3cba752b.png"
    },
    {
      id: 3,
      title: "Developers & Engineers",
      description: "Software engineers and developers building the next generation of AI-powered applications",
      icon: <User className="h-10 w-10 text-purple-500" />,
      image: "/lovable-uploads/44e4bdc5-2fe1-4d3c-af82-f43fa01ac0e8.png"
    },
    {
      id: 4,
      title: "Entrepreneurs & Innovators",
      description: "Startup founders and innovators looking to disrupt industries with AI technology",
      icon: <Lightbulb className="h-10 w-10 text-purple-500" />,
      image: "/lovable-uploads/4af16498-1cd0-4cf2-86b4-63c40b277782.png"
    }
  ];

  return (
    <section id="who-attends" className="py-20 bg-gradient-to-b from-black via-[#F97316] to-black">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="font-['Arial_Black'] text-4xl font-bold mb-3 text-white">Who Attends</h2>
          <h3 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            Join a Diverse AI Community
          </h3>
          <p className="max-w-3xl mx-auto text-lg text-orange-300">
            AI World Congress 2026 on November 25th-26th, London UK Europe, brings together a unique blend of professionals from across the AI ecosystem.
            Connect with peers, find collaborators, and build relationships that last beyond the event.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {attendeeGroups.map((group) => (
            <Card 
              key={group.id} 
              className="bg-white border-blue-300/20 shadow-md overflow-hidden hover:shadow-lg transition-all duration-300"
            >
              <div className="h-48 overflow-hidden">
                <img 
                  src={group.image} 
                  alt={group.title} 
                  className="w-full h-full object-cover"
                />
              </div>
              <CardContent className="p-6">
                <div className="mb-4 flex justify-center">
                  {group.icon}
                </div>
                <h4 className="text-xl font-bold text-blue-900 mb-2 text-center">{group.title}</h4>
                <p className="text-blue-700 text-center">{group.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoAttendsSection;
